import React, { useEffect } from "react";
import { Modal, Form, Input, Button, Divider } from "antd";
import { MailOutlined, SaveOutlined } from "@ant-design/icons";
import "./addAndUpdateEmail.css";

const EmailEditModal = ({
  visible,
  onClose,
  emailData,
  onSave,
  enumsData = {},
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible && emailData) {
      form.setFieldsValue(emailData);
    } else if (visible) {
      form.resetFields();
    }
  }, [visible, emailData, form]);

  const handleFinish = (values) => {
    onSave(values);
  };

  return (
    <Modal
      title={
        <div className="email-edit-modal-header-content">
          <MailOutlined className="email-edit-modal-header-icon" style={{ color: "white" }} />
          <span style={{ color: "white" }}>
            {emailData?._id ? "EDIT EMAIL" : "ADD EMAIL"}
          </span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={600}
      className="email-edit-modal-override"
      styles={{
        header: {
          background: "#0D152B",
          borderRadius: "12px 12px 0 0",
          padding: "20px 24px",
          borderBottom: "none",
        },
        body: {
          padding: "24px",
          background: "#fafafa",
        },
      }}
    >
      <div className="email-edit-modal-form">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
        >
          <div className="email-edit-section">
            <h3 className="email-edit-section-header">Basic Information</h3>
            <div className="email-edit-grid">
              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "Please input name" }]}
              >
                <Input
                  size="large"
                  placeholder="Enter name"
                  className="email-edit-input-override"
                />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
                rules={[
                  { required: true, message: "Please input email" },
                  { type: "email", message: "Please enter valid email" }
                ]}
              >
                <Input
                  size="large"
                  placeholder="Enter email"
                  className="email-edit-input-override"
                />
              </Form.Item>
            </div>
          </div>

          <Divider className="email-edit-divider" />

          {/* Meta Data Section */}
          {/* <div className="email-edit-section">
            <h3 className="email-edit-section-header">Meta Data</h3>
            <Form.Item
              label="Meta Data (Optional)"
              name="meta_data"
              valuePropName="defaultValue"
            >
              <Input.TextArea
                rows={3}
                placeholder='Enter meta data as JSON array: [{"key": "type", "value": "primary"}]'
                className="email-edit-input-override"
              />
            </Form.Item>
          </div> */}

          {/* Action Buttons */}
          <Form.Item style={{ marginBottom: 0 }}>
            <div className="email-edit-actions">
              <Button
                size="large"
                onClick={onClose}
                className="email-edit-btn email-edit-btn-cancel"
              >
                Cancel
              </Button>
              <Button
                htmlType="submit"
                size="large"
                icon={<SaveOutlined />}
                className="email-edit-btn email-edit-btn-primary email-edit-btn-override"
              >
                <span style={{ color: "white" }}>
                  {emailData?._id ? "Edit Email" : "Add Email"}
                </span>
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default EmailEditModal;
